module.exports = __webpack_public_path__ + "img/fitness-active.2325801a.png";